export default "__VITE_ASSET__390ff85e__"